import React from 'react'
import { Collection } from '@morningtrain/react-resources'
import * as Columns from 'support/columns'
import Button from 'ui/buttons/Button'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { PageHeader } from 'ui/layouts'
import Card from 'ui/cards/Card'
import AdminPage from 'pages/app/AdminPage'
import * as Filters from 'support/filters'
import TableHeader from 'ui/table/TableHeader'
import ButtonWrap from 'ui/layouts/ButtonWrap'
import * as UI from 'ui/index'
import {SelectedDepartmentFilter} from "support/filters";

export default function DepartmentsIndex (props) {
  return (
    <AdminPage>
      <Translator namespace='settings.department_suppliers'>
        <PageHeader title={<TranslatedTitle name='titles.index' />}>
          <Link route='app.settings.department_suppliers.create'>
            <Button>
              <Translation name='actions.create' />
            </Button>
          </Link>
        </PageHeader>
        <Card>
          <Collection resourceName='department_suppliers'>
            <SelectedDepartmentFilter />
            <TableHeader>
              <Filters.SearchFilter/>
            </TableHeader>
            <Table>
              <Columns.Text name="name" label={<span><Translation name="columns.name"/></span>}/>
              <Columns.Text name="phone_number" label={<span><Translation name="columns.phone.label"/></span>}/>
              <Columns.Text name="description" label={<span><Translation name="columns.description.label"/></span>}/>
              <Columns.Text name="customer_id" label={<span><Translation name="columns.customer_id.label"/></span>}/>
              <Columns.Column alignment="right">
                <ButtonWrap className="my-0">
                  <Link route="app.settings.department_suppliers.edit" parameters={{ department_supplier: 'model:id' }}>
                    <UI.DefaultEditButton/>
                  </Link>
                </ButtonWrap>
              </Columns.Column>
            </Table>
            <Filters.PaginationFilter/>
          </Collection>
        </Card>
      </Translator>
    </AdminPage>
  )
}
